module.exports = __webpack_public_path__ + "img/Logo-B-1.2755fe99.png";